import react, { useState, useEffect } from "react";
import { KTIcon, toAbsoluteUrl } from "../../../_metronic/helpers";
import {
  deleteMaster,
  getMaster,
  saveMaster,
  updateMaster,
} from "./core/_requests";
import { toast } from "react-toastify";
import { PageTitle } from "../../../_metronic/layout/core/PageData";
import { Paginator } from "primereact/paginator";

const VehicleType = () => {
  const [vehicleType, setVehicleType] = useState<any[]>([]);
  const [pageData, setPageData] = useState<any[]>([]);
  const [vehicleTypeForSearch, setVehicleTypeForSearch] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [editId, setEditId] = useState("");
  const [search, setSearch] = useState("");
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const vehicleTypeList = async () => {
    setLoading(true);
    const response = await getMaster("vehicle_type");
    setVehicleType(response.output);
    setVehicleTypeForSearch(response.output);
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let vehicleTypeName = (
      document.getElementById("vehicleType_name") as HTMLInputElement
    ).value;
    if (vehicleTypeName.length > 0) {
      const response = await saveMaster({
        option_type: "vehicle_type",
        option_value: vehicleTypeName,
      });
      if (response.status == 200) {
        (
          document.getElementById("vehicleType_name") as HTMLInputElement
        ).value = "";
        document.getElementById("atom_vehicleType_add_modal_close")?.click();
        vehicleTypeList();
        toast.success(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      toast.warn("Please Enter VehicleType name..", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleDelete = async () => {
    const response = await deleteMaster(deleteId);
    if (response.status == 200) {
      setDeleteId("");
      document.getElementById("atom_vehicleType_delete_modal_close")?.click();
      vehicleTypeList();
      toast.success(response.message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(response.message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleUpdate = async (id) => {
    let vehicleTypeName = (
      document.getElementById(
        "vehicleType_name_update" + id
      ) as HTMLInputElement
    ).value;
    if (vehicleTypeName.length > 0) {
      const response = await updateMaster(id, {
        option_type: "vehicle_type",
        option_value: vehicleTypeName,
      });
      if (response.status == 200) {
        setEditId("");
        vehicleTypeList();
        toast.success(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setEditId("");
        toast.error(response.message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      toast.warn("Please Enter VehicleType name..", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    if (search.length > 0) {
      const vehicleType = vehicleTypeForSearch.filter((p) =>
        p.option_value?.toLowerCase().includes(search)
      );
      setVehicleType(vehicleType);
    } else {
      setVehicleType(vehicleTypeForSearch);
    }
  }, [search]);

  useEffect(() => {
    vehicleTypeList();
  }, []);

  useEffect(() => {
    let page = vehicleType?.slice(first, first + rows);
    setPageData(page);
  }, [first, rows, vehicleType]);

  return (
    <>
      <PageTitle>Business Settings</PageTitle>
      <div
        className="modal fade"
        id="atom_vehicleType_add_modal"
        aria-hidden="true"
      >
        <div className="modal-dialog mw-550px">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 justify-content-between align-items-center">
              <div className="text-center">
                <h3 className="mb-3">Add Vehicle Type</h3>
              </div>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
                id="atom_vehicleType_add_modal_close"
              >
                <KTIcon iconName="cross" className="fs-1" />
              </div>
            </div>
            <div className="modal-body scroll-y pb-10 pt-5">
              <form onSubmit={handleSubmit}>
                <input
                  name="vehicleType_name"
                  id="vehicleType_name"
                  className="form-control form-control-solid mb-8"
                  placeholder="Enter VehicleType Name.."
                />
                <span className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary me-3"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-sm btn-primary">
                    Save
                  </button>
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="atom_vehicleType_delete_modal"
        aria-hidden="true"
      >
        <div className="modal-dialog mw-550px">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 justify-content-between align-items-center">
              <div className="text-center">
                <h3 className="mb-3">Confirmation</h3>
              </div>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
                id="atom_vehicleType_delete_modal_close"
              >
                <KTIcon iconName="cross" className="fs-1" />
              </div>
            </div>
            <div className="modal-body scroll-y pb-10">
              <p>Are you sure want to delete?</p>
              <span className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary me-3"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  onClick={() => handleDelete()}
                >
                  Yes
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="w-100 h-100">
          <div className="d-flex justify-content-center flex-column align-items-center h-100">
            <div className="spinner-border taskloader" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card-header d-flex align-items-center mobile-padding">
            <h3 className="mb-sm-0 mb-3">Vehicle Type</h3>
            <span className="d-flex">
              <span className="position-relative me-3">
                <input
                  onChange={(e) => setSearch(e.target.value?.toLowerCase())}
                  className="form-control form-control-sm form-control-solid mw-200px"
                  placeholder="Search.."
                />
                <i className="bi bi-search fs-3 me-3 position-absolute top-25 end-0"></i>
              </span>
              <button
                className="btn btn-sm btn-primary me-2 text-nowrap"
                data-bs-toggle="modal"
                data-bs-target="#atom_vehicleType_add_modal"
                onClick={() => {
                  (
                    document.getElementById(
                      "vehicleType_name"
                    ) as HTMLInputElement
                  ).value = "";
                  setDeleteId("");
                  setSearch("");
                  setEditId("");
                }}
              >
                <i className="bi bi-plus-lg"></i> Add Vehicle Type
              </button>
            </span>
          </div>
          <div className="card-body pt-0">
            <div className="overflow-x-auto">
              <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                <thead>
                  <tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                    <th>Sl.No</th>
                    {/* <th>Tag</th> */}
                    <th>VehicleType</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 fw-bold">
                  {vehicleType.length > 0 ? (
                    pageData.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1 + first}</td>
                          {/* <td>
                            <div className='table_item_preview bg-secondary'>
                                {item.name}
                            </div>
                        </td> */}
                          <td>
                            {editId == item.id ? (
                              <input
                                name="vehicleType_name_update"
                                defaultValue={item.option_value}
                                id={"vehicleType_name_update" + item.id}
                                className="form-control form-control-solid"
                                placeholder="Enter VehicleType Name.."
                              />
                            ) : (
                              <span>{item.option_value}</span>
                            )}
                          </td>
                          <td className="text-center text-nowrap">
                            {editId == item.id ? (
                              <>
                                <button
                                  className="btn btn-sm btn-secondary btn-active-color-primary btn-icon me-2"
                                  onClick={() => handleUpdate(item.id)}
                                >
                                  <i className="bi bi-check-lg fs-3"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary btn-active-color-danger btn-icon me-2"
                                  onClick={() => setEditId("")}
                                >
                                  <i className="bi bi-x-lg fs-4"></i>
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-sm btn-secondary btn-active-color-primary btn-icon me-2"
                                  onClick={() => {
                                    setEditId(item.id);
                                  }}
                                >
                                  <i className="bi bi-pencil-fill"></i>
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary btn-active-color-danger btn-icon"
                                  data-bs-toggle="modal"
                                  data-bs-target="#atom_vehicleType_delete_modal"
                                  onClick={() => setDeleteId(item.id)}
                                >
                                  <i className="bi bi-trash"></i>
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>
                        <div className="d-flex text-center w-100 align-content-center justify-content-center">
                          No matching records found
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="table_paginator mt-3 d-flex justify-content-end">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={vehicleType.length}
                rowsPerPageOptions={[10, 50, 100, 500, 1000]}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VehicleType;
